import { Injectable, isDevMode } from '@angular/core';

import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class ContactoService {
  urlBase: string = environment.apiEndpoint;
  constructor( private httpClient: HttpClient ) {
    if (isDevMode()) {
      // console.log('Desarrollo!, URL: ' +this.urlBase );
  } else {
      // console.log('Producción!');
  }
   }

  enviarCorreo( forma ) {

    console.log('desde contacto');
    return this.httpClient.post(this.urlBase + 'enviarCorreoContacto', forma);
  }
}
